module.exports = __webpack_public_path__ + "static/img/app_qr.ce238b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app_qr.jpg
// module id = mHYp
// module chunks = 1